import { subSeconds } from 'date-fns';
import PQueue from 'p-queue';
import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';
import { convertBlocksToSeconds, convertFromWei } from 'modules/api/utils';
import { BASE_PQUEUE_CONFIG } from 'modules/common/const';
import { IPoolUnstake } from 'modules/pool/types';

interface IGetPendingUnstakes {
  poolAddresses: Address[];
  accountAddress: Address;
}

export async function getPendingUnstakes(
  client: PublicClient,
  { poolAddresses, accountAddress }: IGetPendingUnstakes,
): Promise<IPoolUnstake[]> {
  const currentBlock = await client.getBlockNumber();
  const now = new Date().getTime();

  const queue = new PQueue(BASE_PQUEUE_CONFIG);

  const actions = poolAddresses.map(poolAddress => {
    return queue.add(async () => {
      const poolContract = getDelegateStakingPoolContract(client, poolAddress);

      const pendingUnstakes = await poolContract.read.pendingUnstakes([
        accountAddress,
      ]);

      return pendingUnstakes.map(({ amount, block }) => {
        const blockDifference = Number(currentBlock) - Number(block);

        const now = new Date();
        const executedAt = subSeconds(
          now,
          convertBlocksToSeconds(blockDifference),
        );

        return {
          id: `${poolAddress}-${block}-${amount.toString()}`,
          poolAddress,
          executedAt,
          amount: convertFromWei(amount),
        };
      });
    });
  });
  const results = await Promise.allSettled(actions);

  return results
    .map(result => (result.status === 'fulfilled' ? result.value : null))
    .flat()
    .filter((unstake): unstake is IPoolUnstake => !!unstake)
    .sort((a, b) => {
      const timeB = new Date(b.executedAt).getTime();
      const timeA = new Date(a.executedAt).getTime();

      return Math.abs(timeB - now) - Math.abs(timeA - now);
    });
}
